module.exports = __webpack_public_path__ + "img/hys-8.c3e795c1.jpg";